// extracted by mini-css-extract-plugin
export var active = "MobileNav-module--active--6dsxL";
export var language = "MobileNav-module--language--TKB65";
export var link = "MobileNav-module--link--MYsjU";
export var linkSmall = "MobileNav-module--linkSmall--jpvkb";
export var selected = "MobileNav-module--selected--ZCWIO";
export var wrapper = "MobileNav-module--wrapper--W7H3G";